<div class="content-wrapper">
    <div class="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title"> New Movement Request</h4>
           <h5>Requesters Details</h5>
            <form class="forms-sample" #ngNewMovementForm="ngForm" name="form"
               (ngSubmit)="ngNewMovementForm.form.valid && onSubmit()">
           
               <div style="background: #ECECEC;padding:30px;">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="description">Requester Name<span> *</span></label>
                      <input type="text" class="form-control" id="requesterName"  
                        [(ngModel)]="requesterName" 
                        (ngModelChange)="saveToCache()"
                        required
                        placeholder="e.g Mike Adenuga " 
                        name="requesterName" 
                        #requestername="ngModel">
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && requestername.errors">
                       Requester Name is required!
                      </div>
                    </div>
                  </div>
                  
                  <!-- Designation -->
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleInputCity1">Requester Designation<span> *</span></label>
                      <input type="text" class="form-control" id="requesterdesignation" 
                        placeholder="ex: Requester Designation" 
                        [(ngModel)]="requesterDesignation"
                        (ngModelChange)="saveToCache()"
                        #RequesterDesignation="ngModel" 
                        name="requesterdesignation" 
                        required>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && RequesterDesignation.errors">
                        Designation is required!
                      </div>
                    </div>
                  </div>
  
                  <!-- Function  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="selectedfunction">Requester Function<span> *</span></label>
                      <select class="form-control" required 
                        [(ngModel)]="selectedrequesterDepartmentId" 
                        (ngModelChange)="saveToCache()"
                        name="selectedrequesterDepartmentId" 
                        id="selectedrequesterDepartmentId" 
                        #RequesterFunction="ngModel">
                        <option value="">-- Select Function --</option>
                        <option [value]="department.name" *ngFor="let department of Departments">
                          {{department.name}}
                        </option>
                      </select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && RequesterFunction.errors">
                        Requester Function is required!
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="row">
                  <!-- Unit  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="selectedRequesterFunctionId">Requester Unit<span> *</span></label>
                      <ng-select required 
                        [(ngModel)]="selectedRequesterFunctionId"  
                        (ngModelChange)="saveToCache()"
                        id="selectedRequesterFunctionId" 
                        name="selectedRequesterFunctionId" 
                        #RequesterUnit="ngModel">
                        <ng-option *ngFor="let function of Functions" [value]="function.name">
                          {{function.name}}
                        </ng-option>
                      </ng-select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && RequesterUnit.errors">
                        Requester Unit is required!
                      </div>
                    </div>
                  </div>
                  
                  <!-- Request Date  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleInputCity1">Request Date<span> *</span></label>
                      <input type="date" class="form-control" id="requestDate" 
                        placeholder="" 
                        name="requestDate" 
                        required
                        [(ngModel)]="requestDate" 
                        (ngModelChange)="saveToCache()"
                        #RequestsDate="ngModel">
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && RequestsDate.errors">
                        Request Date is required!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <h5> Current Employee Data</h5>
              <br>
              <div style="background: #ECECEC;padding:30px;">
                <div class="row">
                  <!-- Employee Name -->
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleInputCity1">Employee Name<span> *</span></label>
                      <input type="text" class="form-control" id="employeeName" 
                        placeholder="ex: Mike Adenuga" 
                        [(ngModel)]="employeeName"
                        (ngModelChange)="saveToCache()"
                        #empName="ngModel" 
                        name="employeeName" 
                        required>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && empName.errors">
                        Employee Name is required!
                      </div>
                    </div>
                  </div>

                  <!-- SAP Number  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="description">SAP Number<span> *</span></label>
                      <input type="text"  class="form-control" id="sapNumber" 
                        [(ngModel)]="sapNumber"
                        (ngModelChange)="saveToCache()"
                        placeholder="SAP Number " 
                        name="sapNumber"
                        #Sapnumber="ngModel" 
                        required>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && Sapnumber.errors">
                        SAP Number is required!
                      </div>
                    </div>
                  </div>

                  <div class="col">
                    <div class="form-group">
                      <label for="costCenter">Band<span> *</span></label>
                      <ng-select required 
                        [(ngModel)]="Band"   
                        (ngModelChange)="saveToCache()"
                        id="band" 
                        name="band" 
                        #bandemp="ngModel">
                        <ng-option *ngFor="let b of bands" [value]="b.name">
                          {{b.name}}
                        </ng-option>
                      </ng-select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && bandemp.errors">
                        Band is required!
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleInputCity1">Designation<span> *</span></label>
                      <input type="text" class="form-control" id="designation" 
                        placeholder="ex: Designation" 
                        [(ngModel)]="designation"
                        (ngModelChange)="saveToCache()"
                        #Designation="ngModel" 
                        name="designation" 
                        required>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && Designation.errors">
                        Designation is required!
                      </div>
                    </div>
                  </div>

                  <!-- Function  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="selectedfunction">Function<span> *</span></label>
                      <select class="form-control" required 
                        [(ngModel)]="selectedDepartmentId" 
                        (ngModelChange)="saveToCache()"
                        name="selectedDepartmentId"
                        id="selectedDepartmentId" 
                        #function="ngModel">
                        <option value="">-- Select Function --</option>
                        <option [value]="department.name" *ngFor="let department of Departments">
                          {{department.name}}
                        </option>
                      </select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && function.errors">
                        Function is required!
                      </div>
                    </div>
                  </div>
                  
                  <!-- Unit  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="selectedfunction">Unit<span> *</span></label>
                      <ng-select required 
                        [(ngModel)]="selectedFunctionId"  
                        (ngModelChange)="saveToCache()"
                        id="selectedFunctionId" 
                        #unit="ngModel" 
                        name="selectedFunctionId">
                        <ng-option *ngFor="let function of Functions" [value]="function.name">
                          {{function.name}}
                        </ng-option>
                      </ng-select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && unit.errors">
                        Unit is required!
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <!-- N+1 Designation  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="description">N + 1 Designation<span> *</span></label>
                      <input type="text" class="form-control" id="nPlusOneDsignation"  
                        [(ngModel)]="nPlusOne" 
                        (ngModelChange)="saveToCache()"
                        required
                        placeholder=" N + 1 Designation" 
                        name="nPlusOneDsignation" 
                        #nplusonedesignation="ngModel">
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && nplusonedesignation.errors">
                        N + 1 Designation is required!
                      </div>
                    </div>
                  </div>

                  <!-- Location  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="selectedLocation">Location<span> *</span></label>
                      <select class="form-control" required 
                        [(ngModel)]="selectedLocationId" 
                        (ngModelChange)="saveToCache()"
                        name="selectedLocationId" 
                        #location="ngModel" 
                        id="selectedLocationId">
                        <option value="">-- Select Location --</option>
                        <option [value]="location.name" *ngFor="let location of Locations">
                          {{location.name}}
                        </option>
                      </select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && location.errors">
                        Location is required!
                      </div>
                    </div>
                  </div>
                  
                  <!-- Last Promotion Date  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleInputCity1">Last Promotion Date<span> *</span></label>
                      <input type="date" class="form-control" id="promotionDate" 
                        placeholder="" 
                        name="promotionDate"
                        [(ngModel)]="promotionDate" 
                        (ngModelChange)="saveToCache()"
                        required
                        #PromotionDate="ngModel">
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && PromotionDate.errors">
                        Last Promotion Date is required!
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <!-- DATE ASSUMED CURRENT ROLE  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleInputCity1">Date Assumed Current Role<span> *</span></label>
                      <input type="date" class="form-control" id="dateCurrentRole" 
                        placeholder="" 
                        name="dateCurrentRole"
                        [(ngModel)]="dateCurrentRole"  
                        (ngModelChange)="saveToCache()"
                        required
                        #DateCurrentRole="ngModel">
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && DateCurrentRole.errors">
                        Date Assumed Current Role is required!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             
              <br>
              <h5> Proposed Employee Data</h5>
              <br>
             
              <div style="background: #ECECEC;padding:30px;">
                <div class="row">
                  <!-- PROPOSED DESIGNATION -->
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleInputCity1">Proposed Designation<span> *</span></label>
                      <input type="text" class="form-control" id="proposedDesignation" 
                        placeholder="ex:Proposed Designation" 
                        [(ngModel)]="proposedDesignation"
                        (ngModelChange)="saveToCache()"
                        #Designation="ngModel" 
                        name="proposedDesignation" 
                        required>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && Designation.errors">
                        Proposed Designation is required!
                      </div>
                    </div>
                  </div>

                  <!--Proposed N+1   -->
                  <div class="col">
                    <div class="form-group">
                      <label for="description">Proposed N + 1<span> *</span></label>
                      <input type="text" class="form-control" id="ProposedNPlusOneDsignation"  
                        [(ngModel)]="ProposedNPlusOneDsignation" 
                        (ngModelChange)="saveToCache()"
                        required
                        placeholder="Proposed  N + 1 " 
                        name="ProposedNPlusOneDsignation" 
                        #ProposedNPlusOnessignation="ngModel">
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && ProposedNPlusOnessignation.errors">
                        Proposed N + 1  is required!
                      </div>
                    </div>
                  </div>

                  <!--Proposed Function  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="selectedfunction">Proposed Function<span> *</span></label>
                      <select required class="form-control" 
                        [(ngModel)]="selectedProposedDepartmentId" 
                        name="selectedProposedDepartmentId" 
                        #ProposedFunction="ngModel" 
                        id="selectedProposedDepartmentId"  
                        (ngModelChange)="onChangeFunctions($event)">
                        <option value="">-- Select Proposed Function --</option>
                        <option [value]="department.name" *ngFor="let department of Departments">
                          {{department.name}}
                        </option>
                      </select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && ProposedFunction.errors">
                        Proposed Function is required!
                      </div>
                    </div> 
                  </div> 
                </div>

                <div class="row">
                  <!--Proposed Unit  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="selectedfunction">Proposed Unit<span> *</span></label>
                      <ng-select required 
                        [(ngModel)]="selectedProposedFunctionId"  
                        (ngModelChange)="saveToCache()"
                        id="selectedProposedFunctionId" 
                        name="selectedProposedFunctionId" 
                        #Proposedunit="ngModel">
                        <ng-option *ngFor="let function of Functions" [value]="function.name">
                          {{function.name}}
                        </ng-option>
                      </ng-select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && Proposedunit.errors">
                        Proposed Unit is required!
                      </div>
                    </div>
                  </div>

                  <!-- EFFECTIVE DATE  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleInputCity1">Effective Date<span> *</span></label>
                      <input type="date"  class="form-control" id="effectiveDate" 
                        placeholder="" 
                        name="effectiveDate"
                        [(ngModel)]="effectiveDate" 
                        (ngModelChange)="saveToCache()"
                        #EffectiveDate="ngModel" 
                        required>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && EffectiveDate.errors">
                        Date Vacancy Occured is required!
                      </div>
                    </div>
                  </div>
                  
                  <!--Proposed Band  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="proposedBand">Proposed Band<span> *</span></label>
                      <ng-select required  
                        #proposedband="ngModel" 
                        [(ngModel)]="proposedBand"  
                        (ngModelChange)="onChangeBand($event)" 
                        id="proposedBand" 
                        name="proposedBand">
                        <ng-option *ngFor="let b of Proposedbands" [value]="b.name">
                          {{b.name}}
                        </ng-option>
                      </ng-select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && proposedband.errors">
                        Proposed Band is required!
                      </div>
                    </div>
                  </div>
                </div>
          
                <div class="row">
                  <!--Proposed Cost Center  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="costCenter">Proposed Cost Center<span> *</span></label>
                      <ng-select required 
                        [(ngModel)]="selectedProposedCostCenterId" 
                        (ngModelChange)="saveToCache()"
                        id="selectedProposedCostCenterId" 
                        name="selectedProposedCostCenterId" 
                        #proposedcostcenter="ngModel">
                        <ng-option *ngFor="let costCenter of CostCenters" [value]="costCenter.name">
                          {{costCenter.code}} - {{costCenter.name}}
                        </ng-option>
                      </ng-select> 
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && proposedcostcenter.errors">
                        Proposed Cost Center is required!
                      </div>
                    </div>
                  </div>

                  <!--Proposed Location  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="selectedLocation">Proposed Location<span> *</span></label>
                      <select class="form-control" required 
                        [(ngModel)]="selectedProposedLocationId" 
                        (ngModelChange)="saveToCache()"
                        name="selectedLocationId" 
                        #proposedlocation="ngModel"
                        id="selectedLocationId">
                        <option value="">-- Select Proposed Location --</option>
                        <option [value]="location.name" *ngFor="let location of Locations">
                          {{location.name}}
                        </option>
                      </select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && proposedlocation.errors">
                        Proposed location is Required!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <br>
              <h5> Role Details</h5>
              <br>
              <div style="background: #ECECEC;padding:30px;">
                <div class="row">
                  <!-- Date Vacancy Occured  -->
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleInputCity1">Date Vacancy Occured<span> *</span></label>
                      <input type="date"  class="form-control" id="dateVacancyOccured" 
                        placeholder="" 
                        name="dateVacancyOccured"
                        [(ngModel)]="dateVacancyOccured" 
                        (ngModelChange)="saveToCache()"
                        #datevacancyoccured="ngModel" 
                        required>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && datevacancyoccured.errors">
                        Date Vacancy Occured is required!
                      </div>
                    </div>
                  </div>
                  
                  <!-- Reason For Vacancy -->
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleTextarea1">Reason For Vacancy<span> *</span></label>
                      <textarea class="form-control" id="reasonForVacancy" rows="4" 
                        name="reasonForVacancy" 
                        [(ngModel)]="reasonForVacancy" 
                        (ngModelChange)="saveToCache()"
                        #ReasonForVacancy="ngModel"
                        required></textarea>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && ReasonForVacancy.errors">
                        Reason For Vacancy is required!
                      </div>
                    </div>
                  </div>

                  <div class="col">
                    <div class="form-group">
                      <label for="exampleTextarea1">Justification For Movement: <span> *</span></label>
                      <textarea class="form-control" id="justificationForMovement" rows="4" 
                        name="justificationForMovement" 
                        [(ngModel)]="justificationForMovement" 
                        (ngModelChange)="saveToCache()"
                        #JustificationForMovement="ngModel"
                        required></textarea>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && JustificationForMovement.errors">
                        Justification For Movement is required!
                      </div>
                    </div>
                  </div>
                </div>

                <div style="background: #ECECEC;padding:30px;">
                  <label> Type Of Movements</label>
                  <div class="row">
                    <label class="col-sm-0 col-form-label"> TEMPORARY ASSIGNMENT </label>
                    <div class="col-sm-1">
                      <div class="form-check">
                        <label class="form-check-inline"> 
                          <input type="checkbox" class="form-check-input" 
                            [(ngModel)]="typeOfMovement.TemporaryAssignment" 
                            (ngModelChange)="saveToCache()"
                            name="typeOfMovements" 
                            id="temporaryAssignments">
                        </label>
                      </div>   
                    </div>

                    <label class="col-sm-0 col-form-label"> LATERAL MOVE </label>
                    <div class="col-sm-1">
                      <div class="form-check">
                        <label class="form-check-inline"> 
                          <input type="checkbox" class="form-check-input" 
                            [(ngModel)]="typeOfMovement.LateralMove" 
                            (ngModelChange)="saveToCache()"
                            name="typeOfMovements" 
                            id="lateralMove">
                        </label>
                      </div>   
                    </div>

                    <label class="col-sm-0 col-form-label"> PROMOTION </label>
                    <div class="col-sm-1">
                      <div class="form-check">
                        <label class="form-check-inline"> 
                          <input type="checkbox" class="form-check-input" 
                            [(ngModel)]="typeOfMovement.Promotion" 
                            (ngModelChange)="saveToCache()"
                            name="typeOfMovements" 
                            id="promotion">
                        </label>
                      </div>   
                    </div>

                    <label class="col-sm-0 col-form-label"> RELOCATION </label>
                    <div class="col-sm-1">
                      <div class="form-check">
                        <label class="form-check-inline"> 
                          <input type="checkbox" class="form-check-input" 
                            [(ngModel)]="typeOfMovement.Relocation" 
                            (ngModelChange)="saveToCache()"
                            name="typeOfMovements" 
                            id="relocation">
                        </label>
                      </div>   
                    </div>
                  </div>
                  
                  <br>
                  <label> Systems Requirements</label>
                  <br>
              
                  <div class="row">
                    <label class="col-sm-0 col-form-label"> BCMIX </label>
                    <div class="col-sm-1">
                      <div class="form-check">
                        <label class="form-check-inline"> 
                          <input type="checkbox" class="form-check-input" 
                            [(ngModel)]="systemRequirements.bcmix" 
                            (ngModelChange)="saveToCache()"
                            name="systemrequirements" 
                            id="bcmix">
                        </label>
                      </div>   
                    </div>

                    <label class="col-sm-0 col-form-label"> LABMIX </label>
                    <div class="col-sm-1">
                      <div class="form-check">
                        <label class="form-check-inline"> 
                          <input type="checkbox" class="form-check-input" 
                            [(ngModel)]="systemRequirements.labmix" 
                            (ngModelChange)="saveToCache()"
                            name="systemrequirements" 
                            id="labmix">
                        </label>
                      </div>   
                    </div>

                    <label class="col-sm-0 col-form-label"> HOLDIM </label>
                    <div class="col-sm-1">
                      <div class="form-check">
                        <label class="form-check-inline"> 
                          <input type="checkbox" class="form-check-input" 
                            [(ngModel)]="systemRequirements.holdim" 
                            (ngModelChange)="saveToCache()"
                            name="systemrequirements" 
                            id="holdim">
                        </label>
                      </div>   
                    </div>

                    <label class="col-sm-0 col-form-label"> SALESFFORCE </label>
                    <div class="col-sm-1">
                      <div class="form-check">
                        <label class="form-check-inline"> 
                          <input type="checkbox" class="form-check-input" 
                            [(ngModel)]="systemRequirements.salesforce" 
                            (ngModelChange)="saveToCache()"
                            name="systemrequirements" 
                            id="salesforce">
                        </label>
                      </div>   
                    </div>

                    <label class="col-sm-0 col-form-label"> SAP </label>
                    <div class="col-sm-1">
                      <div class="form-check">
                        <label class="form-check-inline"> 
                          <input type="checkbox" class="form-check-input" 
                            [(ngModel)]="systemRequirements.sap" 
                            (ngModelChange)="saveToCache()"
                            name="systemrequirements" 
                            id="sap">
                        </label>
                      </div>   
                    </div>
                  </div>
                </div>
              </div>
              
              <br>
              <h5> Succession Plan & Transition</h5>
              <br>
        
              <div style="background: #ECECEC;padding:30px;">
                <h4>Job Performance / Performance Review (If Applicable)</h4>
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="costCenter">Last Year<span> *</span></label>
                      <ng-select required 
                        [(ngModel)]="lastYear" 
                        (ngModelChange)="saveToCache()"
                        id="lastYear" 
                        rows="4" 
                        name="lastYear" 
                        #lastyear="ngModel">
                        <ng-option *ngFor="let jobperformmance of performanceReview" 
                          [value]="jobperformmance.performance">
                          {{jobperformmance.performance}}
                        </ng-option>
                      </ng-select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && lastyear.errors">
                        Last Year is required!
                      </div>
                    </div>
                  </div>
                
                  <div class="col">
                    <div class="form-group">
                      <label for="costCenter">Two Years<span> *</span></label>
                      <ng-select required 
                        [(ngModel)]="twoYears" 
                        (ngModelChange)="saveToCache()"
                        id="2years" 
                        rows="4" 
                        name="2years" 
                        #twoyears="ngModel">
                        <ng-option *ngFor="let a of performanceReview" [value]="a.performance">
                          {{a.performance}}
                        </ng-option>
                      </ng-select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && twoyears.errors">
                        Two Years is required!
                      </div>
                    </div>
                  </div>
                
                  <div class="col">
                    <div class="form-group">
                      <label for="costCenter">Three Years<span> *</span></label>
                      <ng-select required 
                        [(ngModel)]="threeYears"  
                        (ngModelChange)="saveToCache()"
                        id="3years" 
                        rows="4" 
                        name="3years" 
                        #threeyears="ngModel">
                        <ng-option *ngFor="let c of performanceReview" [value]="c.performance">
                          {{c.performance}}
                        </ng-option>
                      </ng-select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && threeyears.errors">
                        Three Years is required!
                      </div>
                    </div>
                  </div>
                </div>
          
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleTextarea1">Last Talent Review Grid/Comments</label>
                      <input class="form-control" id="lastTalentReview" rows="4" 
                        name="lastTalentReview" 
                        [(ngModel)]="lastTalentReview" 
                        (ngModelChange)="saveToCache()">
                    </div>
                  </div>

                  <div class="col">
                    <div class="form-group">
                      <label for="talentReview">Succession Plan Ready<span> *</span></label>
                      <ng-select required 
                        [(ngModel)]="successionPlanReady" 
                        (ngModelChange)="saveToCache()"
                        id="talentreview" 
                        name="talentreview" 
                        #successionplan="ngModel">
                        <ng-option *ngFor="let c of talentReview" [value]="c.review">
                          {{c.review}}
                        </ng-option>
                      </ng-select>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && successionplan.errors">
                        Succession Plan Ready is required!
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleInputCity1">Development Plan<span> *</span></label>
                      <textarea type="text" class="form-control" id="developmentPlan" 
                        [(ngModel)]="developmentPlan"
                        (ngModelChange)="saveToCache()"
                        #devplan="ngModel" 
                        name="developmentPlan" 
                        required></textarea>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && devplan.errors">
                        Development Plan is required!
                      </div>
                    </div>
                  </div>

                  <div class="col">
                    <div class="form-group">
                      <label for="exampleInputCity1">Identified Gaps<span> *</span></label>
                      <textarea type="text" class="form-control" id="identifiedGaps" 
                        [(ngModel)]="identifiedGaps"
                        (ngModelChange)="saveToCache()"
                        #Gaps="ngModel" 
                        name="identifiedGaps" 
                        required></textarea>
                      <div class="alert alert-danger" role="alert"
                        *ngIf="ngNewMovementForm.submitted && Gaps.errors">
                        Identified Gaps is required!
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="row">
                  <div class="form-group">
                    <label for="document" class="control-label col-md-10">
                      Supporting Information(PDF Only)
                    </label>
                    <div class="col-md-10">
                      <input type="file" 
                        (change)="onFileChange($event)" 
                        placeholder="Upload file" 
                        [(ngModel)]="file" 
                        #document="ngModel"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.xls,.xlsx,.png,.msg,.csv,.zip" 
                        #fileInput 
                        name="fileInput" 
                        style="padding-top:2px;"
                        class="form-control">
                    </div>
                  </div>
                </div>

                <div class="col">
                  <div class="form-group">
                    <label for="exampleTextarea1">Comments</label>
                    <textarea class="form-control" id="comments" rows="4" 
                      name="comments" 
                      [(ngModel)]="comments" 
                      (ngModelChange)="saveToCache()"></textarea>
                  </div>
                </div>
              </div>
              
              <div class="class=col-lg-6 grid-margin">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Approvals</h4>

                    <div style="background: #ECECEC;padding:30px;">
                      <table class="table table-bordered ">
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Unit Head <span> *</span></td>
                            <td>
                              <ng-select required 
                                [(ngModel)]="selectedManagerId"  
                                (ngModelChange)="saveToCache()"
                                id="selectedManagerId"  
                                name="selectedManagerId">
                                <ng-option *ngFor="let manager of Managers" [value]="manager.email">
                                  {{manager.firstName}} - {{manager.email}}
                                </ng-option>
                              </ng-select>
                              <div class="alert alert-danger" 
                                *ngIf="ngNewMovementForm.submitted && selectedManagerId.length==0">
                                <sup>*</sup>Please provide Unit Head to approve
                              </div>
                            </td>
                          </tr>

                          <tr *ngIf="isShowPlantManager">
                            <td>2</td>
                            <td>Plant Manager <span> *</span></td>
                            <td>
                              <ng-select 
                                [(ngModel)]="selectedPlantManagerId"  
                                (ngModelChange)="saveToCache()"
                                id="selectedPlantManagerId" 
                                name="selectedPlantManagerId">
                                <ng-option *ngFor="let plant of PlantManagers" [value]="plant.email">
                                  {{plant.firstName}} - {{plant.email}}
                                </ng-option>
                              </ng-select>
                              <div class="alert alert-danger" 
                                *ngIf="ngNewMovementForm.submitted && selectedfunctionalDirectorId.length==0">
                                <sup>*</sup>Please provide Plant Manager to approve
                              </div>
                            </td>
                          </tr>
                          
                          <tr>
                            <td>{{funcdirectorCount}}</td>
                            <td>Functional Director <span> *</span></td>
                            <td>
                              <ng-select required 
                                [(ngModel)]="selectedfunctionalDirectorId"  
                                (ngModelChange)="saveToCache()"
                                id="selectedfunctionalDirectorId" 
                                name="selectedfunctionalDirectorId">
                                <ng-option *ngFor="let director of FunctionalDirectors" 
                                  [value]="director.email">
                                  {{director.firstName}} - {{director.email}}
                                </ng-option>
                              </ng-select>
                              <div class="alert alert-danger" 
                                *ngIf="ngNewMovementForm.submitted && selectedfunctionalDirectorId.length==0">
                                <sup>*</sup>Please provide Functional Director to approve
                              </div>
                            </td>
                          </tr>
                          
                          <tr>
                            <td>{{hrbpCount}}</td>
                            <td>HRBP <span> *</span></td>
                            <td>
                              <ng-select required 
                                [(ngModel)]="selectedhrbpId"  
                                (ngModelChange)="saveToCache()"
                                id="selectedhrbpId" 
                                name="selectedhrbpId">
                                <ng-option *ngFor="let hrbp of HRBPS" [value]="hrbp.email">
                                  {{hrbp.firstName}} - {{hrbp.email}}
                                </ng-option>
                              </ng-select>
                              <div class="alert alert-danger" 
                                *ngIf="ngNewMovementForm.submitted && selectedhrbpId.length==0">
                                <sup>*</sup>Please provide HRBP to approve
                              </div>
                            </td>
                          </tr>
                      
                          <tr>
                            <td>{{hrCount}}</td>
                            <td>O & HR Director <span> *</span></td>
                            <td>{{ohrdToApprove}}</td>
                          </tr>

                          <tr *ngIf="isShowCEOToApprove">
                            <td>{{ceoCount}}</td>
                            <td>CCEO <span> *</span></td>
                            <td>{{ceoToApprove}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
         
              <br>
              <br>
              <hr>
              <div class="text-left">
                <button type="submit" [disabled]="clicked && ngNewMovementForm.valid"   
                  class="btn btn-primary mr-2 ">Submit</button>
                <button class="btn btn-light">Cancel</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>